"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Kaspersky = function Kaspersky(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.812 12.01c0 .909-.555 1.34-1.25 1.34H9.14v-.55h.392c.42 0 .7-.224.7-.795 0-.563-.265-.842-.712-.842-.43 0-.736.264-.736.83v2.284H8.2V10.69h.579V11h.08a.94.94 0 0 1 .777-.377c.641 0 1.176.466 1.176 1.387zm-3.804-.237l-.384-.039c-.303-.027-.462-.109-.462-.287 0-.21.205-.33.497-.33.302 0 .497.144.512.345h.555c-.023-.52-.423-.839-1.063-.839-.645 0-1.08.342-1.08.843 0 .42.264.691.866.75l.392.038c.237.023.396.07.396.299 0 .206-.147.354-.54.354-.36 0-.539-.164-.601-.385h-.601c.057.5.48.89 1.202.89.68 0 1.119-.358 1.119-.89-.004-.461-.31-.702-.808-.75zm6.044.753c-.089.21-.306.366-.617.366-.422 0-.737-.277-.737-.871 0-.566.29-.882.745-.882.404 0 .633.24.656.606h-1.04v.42h1.611v-.275c0-.766-.508-1.263-1.23-1.263-.672 0-1.317.46-1.317 1.394 0 .936.645 1.394 1.316 1.394.613 0 1.056-.38 1.192-.89zm-9.126-1.903c-.633 0-1.107.331-1.165.839h.621c.043-.186.213-.326.54-.326.419 0 .555.22.555.49v.908c-.237.271-.513.396-.788.396-.288 0-.485-.14-.485-.384 0-.238.155-.385.45-.385h.461v-.416h-.48c-.662 0-1.033.331-1.033.839 0 .474.356.831.946.831.33 0 .621-.132.84-.29h.08v.224h.579v-1.774c.016-.656-.43-.952-1.122-.952zM0 13.348h.579V9.712H0zm2.43-2.658h-.706L.883 11.8v.346l.864 1.202h.718L1.45 11.971zm20.93 0l-.473 1.051c-.117.253-.225.501-.26.669h-.082c-.035-.168-.148-.408-.264-.66l-.474-1.06h-.641l1.115 2.388-.551 1.202h.617L24 10.69zm-2.321 0h-.707l-.842 1.107v.345l.865 1.203h.719l-1.014-1.378zm-3.627 1.083l-.383-.039c-.304-.027-.462-.109-.462-.287 0-.21.205-.33.497-.33.302 0 .496.144.511.346h.555c-.023-.521-.422-.84-1.063-.84-.645 0-1.08.342-1.08.843 0 .42.265.691.866.75l.393.038c.236.023.396.07.396.299 0 .206-.148.354-.54.354-.361 0-.54-.164-.601-.385h-.603c.059.5.481.89 1.204.89.68 0 1.118-.358 1.118-.89 0-.461-.31-.702-.808-.75zm1.196 1.576h.578V9.712h-.578zM14.788 11h-.082v-.31h-.578v2.66h.578v-1.391c0-.473.218-.749.653-.749h.365v-.587h-.213c-.4 0-.571.153-.723.377z"
  }));
};

Kaspersky.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Kaspersky.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Kaspersky;
exports["default"] = _default;